import { deanonEmbedUrl, trackingScriptUrl } from './env'
import type { DeployEnv } from './env'
import { injectScript } from './injectScript'

/**
 * Installs the Chili Piper web-data scripts exactly like a customer site does: the
 * tracking script from the tenant's cpcdp domain and the deanonymization embed from the
 * tenant's chilipiper domain. Idempotent — each script is injected once per page load.
 */
export const loadSnippetScripts = async (
  env: DeployEnv,
  tenantSubdomain: string
): Promise<void> => {
  await Promise.all([
    injectScript(trackingScriptUrl(env, tenantSubdomain)),
    injectScript(deanonEmbedUrl(env, tenantSubdomain)),
  ])
}
